//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { GruposContext } from "../context/GruposContext";


//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerActions() {


    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { isOpenModalCreateGroup, setIsOpenModalCreateGroup } = useContext(GruposContext);



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* BUTTON NOVO GRUPO */}
            <button onClick={() => setIsOpenModalCreateGroup(true)} className="bg-brand-600 hover:bg-brand-700 px-4 py-2 rounded mb-6 h-[40px] w-full sm:max-w-[250px]">
                Novo Grupo
            </button>

        </>
    )
}